// const firebase = require("firebase");
// // Require or import
// require("firebase/firestore");

// import firebase from 'firebase'
// import 'firebase/firestore'
import "core-js/stable";
// import 'es7-object-polyfill'

import firebase from "@firebase/app";
import "@firebase/firestore";
import "@firebase/storage";
import "@firebase/auth";

import dbConfig from "./dbConfig";

const firebaseApp = firebase.initializeApp(dbConfig, "pro");
// const settings = {
//   timestampsInSnapshots: true
// }
export const storage = firebaseApp.storage();
export const firestorePro = firebaseApp;

// console.log('firebaseApp', firebaseApp, 'firestore', firestore)
export default firebaseApp.firestore();
